import { render, staticRenderFns } from "./ShipIndex.vue?vue&type=template&id=53968ab9&scoped=true"
import script from "./ShipIndex.vue?vue&type=script&lang=js"
export * from "./ShipIndex.vue?vue&type=script&lang=js"
import style0 from "./ShipIndex.vue?vue&type=style&index=0&id=53968ab9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53968ab9",
  null
  
)

export default component.exports